// 获取 token
export const getToken = () => {
  return localStorage.getItem('token');
};

// 设置 token
export const setToken = (token) => {
  localStorage.setItem('token', token);
  // 设置token时记录时间
  setLastRequestTime();
};

// 移除 token
export const removeToken = () => {
  localStorage.removeItem('token');
};

// 记录最后一次请求时间
export const setLastRequestTime = () => {
  localStorage.setItem('lastRequestTime', Date.now().toString());
};

// 获取最后一次请求时间
export const getLastRequestTime = () => {
  const time = localStorage.getItem('lastRequestTime');
  return time ? parseInt(time) : null;
};

// 检查token是否过期（24小时）
export const isTokenExpired = () => {
  const token = getToken();
  const lastTime = getLastRequestTime();
  
  console.log('🔍 检查token是否过期:');
  console.log('  - token存在:', !!token);
  console.log('  - lastRequestTime:', lastTime ? new Date(lastTime).toLocaleString() : 'null');
  
  // 如果没有token，返回true（已过期）
  if (!token) {
    console.log('  ❌ 结果: 无token，视为已过期');
    return true;
  }
  
  // 如果没有lastRequestTime，说明是刚登录或数据异常，不应该视为过期
  if (!lastTime) {
    console.log('  ⚠️ 结果: 无lastRequestTime，但有token，视为未过期（可能是刚登录）');
    return false;
  }
  
  const now = Date.now();
  const elapsed = now - lastTime;
  const hours24 = 24 * 60 * 60 * 1000; // 24小时的毫秒数
  const isExpired = elapsed > hours24;
  
  console.log('  - 当前时间:', new Date(now).toLocaleString());
  console.log('  - 距离上次请求:', Math.floor(elapsed / 1000 / 60), '分钟');
  console.log('  - 是否过期:', isExpired);
  
  return isExpired;
};

// 判断是否为管理员
export const isAdmin = () => {
  const userInfo = getUserInfo();
  const result = userInfo?.isAdmin === true;
  console.log('🔍 检查是否为管理员:');
  console.log('  - userInfo:', userInfo);
  console.log('  - isAdmin:', result);
  return result;
};

// 获取用户信息
export const getUserInfo = () => {
  const userInfo = localStorage.getItem('userInfo');
  return userInfo ? JSON.parse(userInfo) : null;
};

// 设置用户信息
export const setUserInfo = (userInfo) => {
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
};

// 清除所有用户数据
export const clearUserData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('lastRequestTime');
};

// 检查是否已登录
export const isAuthenticated = () => {
  return !!getToken();
};

